export default __webpack_public_path__ + "/dist/images/expert-voice.b833fafa7e19274e4177a0be19d839b8.png";